var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32538 2.14607L11.8537 5.67412L4.92393 12.6047C4.73088 12.7978 4.49076 12.9372 4.22732 13.0091L0.659915 13.9818C0.571002 14.0059 0.477294 14.0061 0.388275 13.9824C0.299256 13.9586 0.218084 13.9118 0.152976 13.8466C0.0878673 13.7815 0.0411319 13.7002 0.0174994 13.6112C-0.00613314 13.5222 -0.00582413 13.4285 0.0183952 13.3396L0.991134 9.7725C1.06303 9.50909 1.20243 9.26899 1.39557 9.07596L8.32398 2.14607H8.32538ZM13.2693 0.730671C13.7371 1.19852 14 1.83306 14 2.49469C14 3.15633 13.7371 3.79086 13.2693 4.25871L12.5929 4.93504L9.06452 1.407L9.74091 0.730671C10.2088 0.26283 10.8434 0 11.5051 0C12.1668 0 12.8014 0.26283 13.2693 0.730671Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/Pencil_icon.e5dbd91c8e8ca844cc35a176f5fe1b35.svg";
export { ForwardRef as ReactComponent };